<template>
  <div class="thing">
    <h1>Contact me</h1>
    <form class="contact-form" @submit.prevent="sendEmail">
      <label>Name</label>
      <input type="text" name="user_name" class="email" />
      <label>Email</label>
      <input type="email" name="user_email" class="email" />
      <label>Message</label>
      <textarea name="message" id="message"></textarea>
      <input type="submit" value="Send" class="button" />
    </form>

  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  methods: {
    sendEmail: (e) => {
      emailjs
        .sendForm(
          "service_yiw40pn",
          "template_2cvkiwz",
          e.target,
          "user_NEIlHvmyasiZTUs6eM9CI"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );
    },
  },
};
</script>

<style type="scss" scoped>
.thing {
  background: #000;
  width: calc(100% - 40px);
  color: #fff;
  padding: 20px;
  display: grid;
  place-items: center;
}
.contact-form {
  display: grid;
  grid-template-columns: 1fr;
  height: 50vh;
  width: 50vh;
}
.email {
  width: 45vh;
  border-radius: 5%;
  font-size: 1.5em;
}
#message {
  border-radius: 3%;
  font-size: 1.5em;
  width: 45vh;
}
.button{
  color: #fff;
  background:yellowgreen;
  margin: 10px 0 0 0;
  width: 45vh;
  font-family: 'Stalinist One', cursive;
  font-size: 2em;
}
label{
  margin: 25px 0 0 0;
}
a{
  text-decoration: none;
  color:tomato;
}

@media screen and (max-width: 600px) {
  #message {
    height: 100px;
  }
}
</style>
